import { Box, Skeleton, Typography } from "@mui/material";
import { colors } from "../../../theme/palette";
import { useTranslation } from "react-i18next";

type Interaction = {
  title: string;
  value: number;
  ratio: string | null;
  state: string | null;
};

export const InteractionBox = ({ interaction, duration }: { interaction: Interaction; duration: string }) => {
  const { title, value, ratio, state } = interaction;
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        width: "calc(50% - 7px)",
        minHeight: "130px",
        padding: "25px 16px",
        display: "flex",
        flexDirection: "column",
        rowGap: "3px",
        border: "1px solid #EAECF0",
        borderRadius: "8px",
      }}
    >
      <Typography
        sx={{
          color: colors.Black100,
          fontFamily: "Montserrat",
          fontSize: "20px",
          fontStyle: "normal",
          fontWeight: 700,
          lineHeight: "normal",
        }}
      >
        {value}
      </Typography>
      <Typography
        sx={{
          color: colors.Dark800,
          fontFamily: "Montserrat",
          fontSize: "14px",
          fontStyle: "normal",
          fontWeight: 400,
          lineHeight: "24px",
        }}
      >
        {t(`pages.dashboard.${title}`)}
      </Typography>
      <Typography
        component="div"
        sx={{
          color: colors.Dark800,
          fontFamily: "Montserrat",
          fontSize: "12px",
          fontStyle: "normal",
          fontWeight: 400,
          lineHeight: "normal",
          display: "flex",
          alignItems: "center",
          columnGap: "4px",
        }}
      >
        {ratio && (
          <Typography
            component="span"
            sx={{
              color: state === "INCREASE" ? colors.Green100 : state === "DECREASE" ? colors.Red100 : colors.Dark1000,
              fontFamily: "Montserrat",
              fontSize: "13px",
              fontStyle: "normal",
              fontWeight: 700,
              lineHeight: "16px",
            }}
          >
            {ratio}
          </Typography>
        )}
        {t(`pages.dashboard.${duration}`)}
      </Typography>
    </Box>
  );
};

export const InteractionBoxLoader = () => {
  return (
    <Box
      sx={{
        width: "calc(50% - 7px)",
        minHeight: "130px",
        padding: "25px 16px",
        display: "flex",
        flexDirection: "column",
        rowGap: "8px",
        border: "1px solid #EAECF0",
        borderRadius: "8px",
      }}
    >
      <Skeleton variant="text" width="30%" height={32} sx={{ backgroundColor: "#e0e0e0" }} />
      <Skeleton variant="text" width="50%" height={20} sx={{ backgroundColor: "#f0f0f0" }} />
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          columnGap: "4px",
        }}
      >
        <Skeleton variant="text" width="20%" height={16} sx={{ backgroundColor: "#e0e0e0" }} />
        <Skeleton variant="text" width="30%" height={16} sx={{ backgroundColor: "#f0f0f0" }} />
      </Box>
    </Box>
  );
};
